module.exports = __webpack_public_path__ + "static/media/patients.4564deb6.svg";